import { firebaseConfig } from "../firebase/config";

export const NOTIFICATION_DOC_ID = "infinft-royale";

export const DEFAULT_NOTIFICATION_PREFERENCES = Object.freeze({
  email: true,
  push: true,
  sms: true,
});

const normalizePreferenceValue = (value, fallback = true) =>
  typeof value === "boolean" ? value : fallback;

export const normalizeNotificationPreferences = (value = {}) => ({
  email: normalizePreferenceValue(
    value?.email,
    DEFAULT_NOTIFICATION_PREFERENCES.email,
  ),
  push: normalizePreferenceValue(
    value?.push,
    DEFAULT_NOTIFICATION_PREFERENCES.push,
  ),
  sms: normalizePreferenceValue(
    value?.sms,
    DEFAULT_NOTIFICATION_PREFERENCES.sms,
  ),
});

export const getAnnouncementUnsubscribePageUrl = (origin = "") => {
  const explicit = String(process.env.REACT_APP_UNSUBSCRIBE_URL || "").trim();
  if (explicit) return explicit;

  const normalizedOrigin = String(origin || "").trim().replace(/\/+$/, "");
  return normalizedOrigin ? `${normalizedOrigin}/unsubscribe` : "/unsubscribe";
};

export const getPublicUnsubscribeEndpoint = () =>
  `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net/app/public/unsubscribe_email`;
